import React, {FC} from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon';
import RankIcon from '/component/base/RankIcon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {Rank} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './PersonalRankSummary.style';

interface PersonalRankSummaryProps {
  tt: (key: string, value: string) => string;
  rankId: number;
  rankName: string;
  nextRankName: string;
  hasNextRank: boolean;
  percent: any;
  onPress: () => void;
}

export const PersonalRankSummary: FC<PersonalRankSummaryProps> = ({
  tt = withTranslation.ttDefaultProp,
  rankId = 0,
  rankName = '',
  nextRankName = '',
  percent = 0,
  hasNextRank = true,
  onPress = () => {},
}: PersonalRankSummaryProps) => {
  const baseViewProps = {
    style: styles.base,
    onPress: onPress,
  };
  const formattedPercent = (() => {
    const percentValue = parseFloat(percent);
    return percentValue % 1 === 0
      ? percentValue.toString()
      : percentValue.toFixed(2);
  })();

  const detailText = hasNextRank
    ? tt('showDetail', `${formattedPercent}% of the way to ${nextRankName}`)
    : tt(
        'highestRankDescription',
        'Congratulations on achieving the highest rank!',
      );

  // return (
  //   <TouchableOpacity
  //     {...baseViewProps}
  //     accessibilityRole="button"
  //     accessibilityLabel={`${rankName}. ${detailText}`}>
  //     <View style={styles.columns}>
  //       <View style={styles.textColumn}>
  //         <View
  //           accessible={true}
  //           accessibilityLabel={rankName}
  //           accessibilityRole="header">
  //           <Text allowFontScaling maxFontSizeMultiplier={2}
  //             testID={Rank.rankProgressDescription}
  //             variant="heading"
  //             style={styles.progressDescription}>
  //             {rankName}
  //           </Text>
  //         </View>
  //         <View
  //           style={styles.showDetail}
  //           accessible={true}
  //           accessibilityLabel={detailText}>
  //           <Text allowFontScaling maxFontSizeMultiplier={2} testID={Rank.rankSeeProgress} style={styles.text}>
  //             {detailText}
  //           </Text>
  //           <Icon
  //             name="arrow-right"
  //             style={styles.showDetailArrow}
  //             accessible={false}
  //           />
  //         </View>
  //       </View>
  //       <View style={styles.rankIconColumn}>
  //         <RankIcon rankId={rankId} scale={4 / 3} />
  //       </View>
  //     </View>
  //   </TouchableOpacity>
  // );

  return (
    <View style={styles.base}>
      {/* Rank Name Announced First as Header */}
      <View
        accessible={true}
        accessibilityRole="header"
        accessibilityLabel={rankName}
        style={styles.textColumn}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          testID={Rank.rankProgressDescription}
          variant="heading"
          style={styles.progressDescription}>
          {rankName}
        </Text>
      </View>

      {/* Touchable Detail - Entire View Focusable as Button */}
      <TouchableOpacity
        {...baseViewProps}
        style={styles.columns} // or use your textColumn + rankIconColumn arrangement
        onPress={onPress}
        accessibilityRole="button"
        {...{
          accessibilityLabel: `${detailText}`,
          accessibilityHint: 'Double tap to view rank details',
        }}>
        <View style={styles.textColumn}>
          <View style={styles.showDetail}>
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              testID={Rank.rankSeeProgress}
              style={styles.text}>
              {detailText}
            </Text>
            <Icon
              name="arrow-right"
              style={styles.showDetailArrow}
              accessible={false}
            />
          </View>
        </View>
        <View style={styles.rankIconColumn}>
          <RankIcon rankId={rankId} scale={4 / 3} />
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default withTranslation('rankProgressCard.personalSummary')(
  PersonalRankSummary,
);
